/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} NotificationsInputs */

const th_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือน`)
};

const en_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const ja_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const zh_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const es_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones`)
};

const pt_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

const id_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi`)
};

const fr_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const tl_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga notipikasyon`)
};

const vi_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo`)
};

const ko_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림`)
};

const de_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

const ru_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления`)
};

const tr_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimler`)
};

const it_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche`)
};

const pl_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia`)
};

const uk_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення`)
};

const hi_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ`)
};

const ar_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات`)
};

const ms_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan`)
};

const bn_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিজ্ঞপ্তি`)
};

const zh_tw2_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const zh_hk2_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const ur_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلاعات`)
};

const fa_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعلان‌ها`)
};

const sw_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arifa`)
};

const nl_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {NotificationsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const notifications = /** @type {((inputs?: NotificationsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NotificationsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_notifications(inputs)
	if (locale === "ja") return ja_notifications(inputs)
	if (locale === "zh") return zh_notifications(inputs)
	if (locale === "es") return es_notifications(inputs)
	if (locale === "pt") return pt_notifications(inputs)
	if (locale === "id") return id_notifications(inputs)
	if (locale === "fr") return fr_notifications(inputs)
	if (locale === "tl") return tl_notifications(inputs)
	if (locale === "vi") return vi_notifications(inputs)
	if (locale === "ko") return ko_notifications(inputs)
	if (locale === "de") return de_notifications(inputs)
	if (locale === "ru") return ru_notifications(inputs)
	if (locale === "tr") return tr_notifications(inputs)
	if (locale === "it") return it_notifications(inputs)
	if (locale === "pl") return pl_notifications(inputs)
	if (locale === "uk") return uk_notifications(inputs)
	if (locale === "hi") return hi_notifications(inputs)
	if (locale === "ar") return ar_notifications(inputs)
	if (locale === "ms") return ms_notifications(inputs)
	if (locale === "bn") return bn_notifications(inputs)
	if (locale === "zh-TW") return zh_tw2_notifications(inputs)
	if (locale === "zh-HK") return zh_hk2_notifications(inputs)
	if (locale === "ur") return ur_notifications(inputs)
	if (locale === "fa") return fa_notifications(inputs)
	if (locale === "sw") return sw_notifications(inputs)
	if (locale === "nl") return nl_notifications(inputs)
	return en_notifications(inputs)
});